import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultaAgendamentosRequest } from './types';

// ACTIONS
import {
	consultaAgendamentosSuccess,
	consultaAgendamentosFailure,
} from './actions';

function* consultaAgendamentos(request: ReducerAction) {
	const { payload }: { payload: ConsultaAgendamentosRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`divisao-equitativa/${CHANNEL}/consulta/${payload.cpf}`,
		{},
		undefined,
		true,
	);

	if (response.status === 200) {
		yield put(consultaAgendamentosSuccess(response));
	} else {
		yield put(consultaAgendamentosFailure(response.data));
	}
}

export default all([
	takeLatest(Types.CONSULTA_AGENDAMENTOS_REQUEST, consultaAgendamentos),
]);
